import React from 'react';
import injectSheet from 'react-jss';
import glamorous from 'glamorous';
import { Form, Input, Button, Row, Col } from 'antd';
import { PulseLoader } from 'react-spinners';

const { TextArea } = Input;

const FormItem = Form.Item;

const styles = () => ({
  root: {
    padding: '1em 0',
  },
  content: {
    paddingTop: '1em',
  },
  button: {
    display: 'grid',
    margin: 'auto',
    color: 'black',
  },
});

const StyledButton = glamorous(Button)({
  display: 'grid',
  alignItems: 'center',
  alignContent: 'center',
  margin: 'auto',
  color: 'black',
  '&:focus': {
    color: 'black',
  },
});
const Success = glamorous.div({
  textAlign: 'center',
  borderRadius: '10px',
  backgroundColor: '#D8EACE',
  color: '#769878',
  padding: '0 0 5px 0',
  margin: '10px 0',
  '&::before': {
    content: '✔ ',
    fontSize: '20px',
  },
});

const Error = glamorous.div({
  textAlign: 'center',
  borderRadius: '10px',
  backgroundColor: '#EEDDDB',
  color: '#8D5253',
  padding: '0 0 5px 0',
  margin: '10px 0',
  '&::before': {
    content: '⨯ ',
    fontSize: '20px',
  },
});

const renderResponseMessage = response =>
  ({
    success: <Success>Votre demande a bien été envoyée</Success>,
    error: <Error>Une erreur est survenue, merci de réessayer ultérieurement</Error>,
  }[response]);


function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}
class FormContact extends React.Component {
  constructor() {
    super();
    this.state = { response: '', loading: false };
  }
  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }
  handleSubmit = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        fetch('/email', {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values),
        })
          .then((response) => {
            if (response.ok) {
              this.setState({ response: 'success', loading: false });
            } else {
              this.setState({ response: 'error', loading: false });
            }
          });
      }
    });
  }
  render() {
    const { classes } = this.props;
    const {
      getFieldDecorator, getFieldsError, getFieldError, isFieldTouched,
    } = this.props.form;

    // Only show error after a field is touched.
    const nomError = isFieldTouched('nom') && getFieldError('nom');
    const prenomError = isFieldTouched('prenom') && getFieldError('prenom');
    const emailError = isFieldTouched('email') && getFieldError('email');
    const messageError = isFieldTouched('message') && getFieldError('message');
    return (
      <Row type="flex" justify="center">
        <Col span={18} className={classes.root} >
          <Row type="flex" justify="start">
            <h1>Me contacter</h1>
          </Row>
          {renderResponseMessage(this.state.response)}

          <Form layout="vertical" onSubmit={this.handleSubmit}>
            <Row justify="center" type="flex" gutter={24} className={classes.content} >
              <Col md={12} xs={24}>
                <FormItem label="Nom" validateStatus={nomError ? 'error' : ''} help={nomError || ''}>
                  {getFieldDecorator('lastname', {
                    rules: [{ required: true, message: 'Veuillez renseigner votre nom' }],
                  })(<Input name="lastname" placeholder="Nom" />)}
                </FormItem>
                <FormItem label="Prénom" validateStatus={prenomError ? 'error' : ''} help={prenomError || ''}>
                  {getFieldDecorator('firstname', {
                    rules: [{ required: true, message: 'Veuillez renseigner votre prénom' }],
                  })(<Input name="firstname" placeholder="Prénom" />)}
                </FormItem>
                <FormItem label="Email" validateStatus={emailError ? 'error' : ''} help={emailError || ''}>
                  {getFieldDecorator('sender', {
                    rules: [
                      {
                        type: 'email',
                        message: "Cette adresse email n'est pas valide",
                      },
                      {
                        required: true,
                        message: 'Veuillez renseigner votre adresse email',
                      },
                    ],
                  })(<Input name="sender" placeholder="adresse@gmail.com" />)}
                </FormItem>
              </Col>
              <Col md={12} xs={24}>
                <FormItem
                  label="Message"
                  validateStatus={messageError ? 'error' : ''}
                  help={messageError || ''}
                  hasFeedback
                >
                  {getFieldDecorator('message', {
                    rules: [{ required: true, message: 'Votre message est vide' }],
                  })(<TextArea name="message" placeholder="Message" rows={6} />)}
                </FormItem>


                <StyledButton type="primary" htmlType="submit" disabled={hasErrors(getFieldsError())}>
                  {this.state.loading ? <PulseLoader
                    color="#B68962"
                    size={5}
                  /> : 'Envoyer'}
                </StyledButton>

              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    );
  }
}

const WrappedFormContact = Form.create()(FormContact);

export default injectSheet(styles)(WrappedFormContact);



// WEBPACK FOOTER //
// ./src/app/pages/contact/components/FormContact.jsx